import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

/**
 * Compact marketplace-wide disclaimer + 2A supporter statement.
 * Shown at the top of Marketplace and ListingDetail.
 */
export const MarketplaceDisclaimer = ({ compact = false }) => (
  <div
    className="relative rounded-md border-l-4 border-secondary bg-secondary/5 p-4 flex items-start gap-3"
    data-testid="marketplace-disclaimer"
  >
    <div className="w-8 h-8 rounded-md bg-secondary/15 flex items-center justify-center shrink-0">
      <Shield className="w-4 h-4 text-secondary" />
    </div>
    <div className="text-sm leading-relaxed">
      <span className="font-semibold text-foreground">Buyer & seller assume all liability.</span>{" "}
      Florida Sportsman is a listing platform only — we do not sell, ship, or inspect any item. All transactions
      must comply with federal, Florida, and local law. We are proud supporters of the{" "}
      <span className="text-secondary font-semibold">Second Amendment</span> and the{" "}
      <span className="text-secondary font-semibold">NRA</span>, and equally firm about lawful ownership.
      {!compact && (
        <>
          {" "}
          <Link to="/rules" className="underline text-primary hover:text-primary/80" data-testid="link-rules-disclaimer">
            Community rules
          </Link>
          {" · "}
          <Link to="/terms" className="underline text-primary hover:text-primary/80" data-testid="link-terms-disclaimer">
            Terms
          </Link>
        </>
      )}
    </div>
  </div>
);
